export const funcionalidadDeshabilitada = (termicas, funcionalidad) => {
    return termicas && (Array.isArray(termicas) ? termicas?.length > 0 : true) && !funcionalidad
}